import type { LegacyRef } from 'react';
import { forwardRef } from 'react';
import type { NavProps } from './NavComponent';
import NavComponent from './NavComponent';

export interface VerticalNavProps extends NavProps {
  open?: boolean;
}

function VerticalNavComponent(
  { children, open = false, ...props }: VerticalNavProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <NavComponent
      ref={ref}
      {...props}
      className={`vertical-nav ${open ? 'open' : ''} ${props.className || ''}`}
    >
      {children}
    </NavComponent>
  );
}

export default forwardRef(VerticalNavComponent);
